import { Chip, ChipProps } from "~/ui-library";
import NextLink from "next/link";
import { useAnalytics } from "~/components/Analytics";

type Tag = {
  name: string;
  slug: string;
};

export interface TagsProps extends Omit<ChipProps<any>, "children"> {
  tags: Tag[];
}

export const Tags = ({ tags, ...rest }: TagsProps): JSX.Element => {
  const { analyticsEnhancedTrack } = useAnalytics();

  const onClick = (tag: Tag) => {
    analyticsEnhancedTrack("Content: Tag Click", {
      clickedTagValue: tag.slug,
    });
  };
  return (
    <div className="flex flex-wrap gap-s">
      {tags.map((tag) => (
        <NextLink
          key={tag.name}
          href={`/tags/${tag.slug}`}
          onClick={() => onClick(tag)}
        >
          <Chip key={tag.name} {...rest}>
            {tag.name}
          </Chip>
        </NextLink>
      ))}
    </div>
  );
};
